// extracted by mini-css-extract-plugin
export default {"uploadContainer":"styles_uploadContainer__Tc-lW","uploadButton":"styles_uploadButton__MryXJ","icon":"styles_icon__dPbcO","input":"styles_input__TXjyK"};